import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

export const PhoneWrapper = styled.div`
  display: flex;
`;

export const PhoneItemWrapper = styled.div`
  ${ifProp(
    'isFullWidth',
    css`
      width: 100%;
    `
  )};

  &:first-child {
    margin-right: 8px;
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  min-height: 20px;
`;

export const StyledForm = styled.form`
  display: grid;
  grid-column-gap: 8px;
  grid-column: span 16 !important;
  grid-template-columns: repeat(16, 1fr);

  label {
    white-space: nowrap;
  }
`;
